module.exports = __webpack_public_path__ + "static/media/Authentication-icon.ee99c1f9.svg";